import React from 'react';

import { fg } from '@confluence/feature-gating';
import { LoadableAfterPaint, LoadablePaint } from '@confluence/loadable';

import type { ComponentProps as MainButtonsProps } from './MainButtons';

const MainButtonsLoader = LoadableAfterPaint({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-MainButtons" */ './MainButtons'))
			.MainButtons;
	},
});

const MainButtonsSSRLoader = LoadablePaint({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-MainButtons" */ './MainButtons'))
			.MainButtons;
	},
});

export const MainButtons = (props: MainButtonsProps) => (
	<>
		{!fg('confluence_frontend_content_wrapper') ? (
			<MainButtonsLoader {...props} />
		) : fg('confluence_frontend_usd_ssr') ? (
			<MainButtonsSSRLoader {...props} />
		) : (
			<MainButtonsLoader {...props} />
		)}
	</>
);

export const loadMainButtons = async () => MainButtonsLoader.preload();
